import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full border-b pb-2" }
const _hoisted_2 = { class: "ml-2.5 font-normal text-base" }
const _hoisted_3 = ["innerHTML"]

import { onMounted, ref } from "vue"
import { Template } from "@/shared/models/template"
import { useConfigStore } from "@/stores/config"
import { renderTemplate } from "@/shared/utils/helpers"
import { Contact } from "@/shared/models/contact"
import { Agency } from "@/shared/models/agency"
import { Agent } from "@/shared/models/agent"
import { useMessageThemeStore } from "@/stores/message-theme"
import { useContactsStore } from "@/stores/contacts"

interface Props {
    modelValue: Template
}

export default /*@__PURE__*/_defineComponent({
  __name: 'TemplatePreviewStep',
  props: {
    modelValue: {}
  },
  setup(__props: any) {

const props = __props
const configStore = useConfigStore()
const messageThemeStore = useMessageThemeStore()
const contactStore = useContactsStore()

const templateBody = ref(props.modelValue.body)

function getBodyOfMessageTheme(channel: string) {
    return messageThemeStore.messageThemes.find((theme) => theme.channel === channel)?.body
}

function getTheme() {
    if (props.modelValue.templateType === "email") {
        return getBodyOfMessageTheme("RichEmail")
    }
    return getBodyOfMessageTheme("TextMessage")
}

function addSignatureToTemplateBody() {
    const models = {
        contact: contactStore.contact as Contact,
        agency: {} as Agency,
        agent: {} as Agent,
    }
    const theme = getTheme() || ""
    const signature = configStore?.signature?.body || ""

    templateBody.value = renderTemplate(props.modelValue.body, configStore.prototypes, models, theme, signature)
    if (props.modelValue.templateType === "sms") {
        // remove html tags and replace \n with <br>
        templateBody.value = templateBody.value.replace(/(<([^>]+)>)/gi, "").replace(/\n/g, "<br>")
    }
}

onMounted(() => {
    addSignatureToTemplateBody()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "border-gray-300 border rounded-md text-sm px-4 py-2 h-[344px] overflow-y-auto",
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent","stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "font-medium" }, "Subject:", -1)),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.modelValue.subject), 1)
    ]),
    _createElementVNode("div", {
      innerHTML: templateBody.value,
      class: "pt-2"
    }, null, 8, _hoisted_3)
  ]))
}
}

})